import { createSlice } from "@reduxjs/toolkit";

const initialVarfinancialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  lastError: null,
  varfinancialForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const varfinancialSlice = createSlice({
  name: "varfinancial",
  initialState: initialVarfinancialState,
  reducers: {
		catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
		varfinancialFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    varfinancialCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.varfinancial.push(action.payload.varfinancial);
    },
    varfinancialDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.varfinancial.filter(el => el.varfinancial_id !== action.payload.id);
    },
    getVarfinancial: (state, action) => {
      state.actionsLoading = false;
      state.varfinancialForEdit = action.payload.varfinancialForEdit;
      state.error = null;
    },
    // updateProduct
    varfinancialUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.varfinancial = state.entities.varfinancial.map(entity => {
        if (entity.varfinancial_id === action.payload.varfinancial.varfinancial_id) {
          return action.payload.varfinancial;
        }
        return entity;
      });
    },
  },
});
